module.exports = __webpack_public_path__ + "img/3.8a7b308b.png";